import ImportVM from './import-vm';
import ExternalImportsServices from './services.js';
export default {
  init: function(){
    console.log('Initializing Kadenze.ExternalImports');
    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;
    validationOptions.insertMessages = false;
    validationOptions.grouping = { deep: true, observable: true, live: true };
    self.viewmodel = new ImportVM();
    ko.applyBindingsWithValidation(self.viewmodel, document.getElementById('js-external-imports'), validationOptions);
  }
};

